// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SettingOutlinedSvg from "@ant-design/icons-svg/es/asn/SettingOutlined";
import AntdIcon from '../components/AntdIcon';

var SettingOutlined = function SettingOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SettingOutlinedSvg
  }));
};

SettingOutlined.displayName = 'SettingOutlined';
export default React.forwardRef(SettingOutlined);